import { CSSProperties } from 'react';
import { FieldError } from 'react-hook-form';

import Visible from 'coreOld/components/Visible';
import { AlignText, Size } from 'coreOld/enums';

import { Icon, Input, Wrapper } from './textInputStyle';
import TextInputWithController from './TextInputWithController';

interface IProps {
  htmlFor?: string;
  name?: string;
  style?: CSSProperties;
  size?: Size;
  type?: string;
  icon?: JSX.Element;
  endIcon?: JSX.Element;
  placeholder?: string;
  label?: string;
  disabled?: boolean;
  editable?: boolean;
  fontInherit?: boolean;
  value?: string;
  defaultValue?: string;
  hasBorder?: boolean;
  textAlign?: AlignText;
  control?;
  onChange?;
  onChangeFilter?;
  onBlur?;
  onKeyDown?;
  onClick?;
  error?: FieldError | string;
  showFieldError?: boolean;
  autoFocus?: boolean;
}

const TextInputView = ({
  name,
  style,
  size,
  type,
  icon,
  endIcon,
  placeholder,
  label,
  disabled,
  editable = true,
  fontInherit = false,
  value,
  control,
  onChange,
  onClick,
  onBlur,
  onKeyDown,
  htmlFor,
  defaultValue = '',
  hasBorder = true,
  textAlign = AlignText.LEFT,
  error,
  showFieldError = false,
  autoFocus = false,
}: IProps) => {
  const isDisabledState = disabled && !editable;
  const commonProps = {
    name,
    id: htmlFor || name,
    hasIcon: Boolean(icon),
    textAlign,
    placeholder,
    disabled,
    isDisabledState,
    isEditable: editable,
    fontInherit,
    hasBorder,
    style,
    size,
    type,
    onBlur,
    onKeyDown,
    error,
    showFieldError,
    autoFocus,
  };

  const input = control ? (
    <TextInputWithController
      {...{
        ...commonProps,
        control,
        label,
        defaultValue,
        onChange,
      }}
    />
  ) : (
    <Input
      {...{
        ...commonProps,
        value: isDisabledState && !value ? '-' : value || defaultValue,
        onChange: (event) => onChange && onChange(event),
      }}
    />
  );

  return (
    <Wrapper>
      <Visible when={Boolean(icon)}>
        <Icon onClick={onClick}>{icon}</Icon>
      </Visible>

      {input}

      <Visible when={Boolean(endIcon)}>
        <Icon onClick={onClick} endIcon={true}>
          {endIcon}
        </Icon>
      </Visible>
    </Wrapper>
  );
};

export default TextInputView;
